import { Timestamp } from 'firebase/firestore';
import type { BillingMode } from './catalogDesignation';

export const DESIGNATION_SECTIONS = [
  'rd',
  'npi',
  'prototypes',
  'nre',
  'certification',
  'production',
  'autres',
] as const;
export type DesignationSection = (typeof DESIGNATION_SECTIONS)[number];

export const DESIGNATION_STATUSES = [
  'pending',
  'ordered',
  'on-hold',
  'closed',
] as const;
export type DesignationStatus = (typeof DESIGNATION_STATUSES)[number];

export interface Designation {
  id: string;
  section: DesignationSection;
  category?: string;
  name: string;
  billingMode: BillingMode;
  initialOffer: number;
  orderedAmount: number;
  customerPO?: string;
  altyorPO?: string;
  subContracting: boolean;
  status: DesignationStatus;
  /**
   * Declared technical progress (0–100 %), set manually from the Finance
   * tab quick-edit (rd_manager / direction / PM / finance). Independent
   * from the computed `percentCompletion` (hours-based) — the gap between
   * the two is the budget-drift signal. Never touched by Cloud Functions.
   */
  progress?: number;
  // Hourly-only fields (absent on fixed lines):
  hoursSold?: number;
  hoursSpent?: number;
  remainingHours?: number;
  percentCompletion?: number;
  hourlyRateOverride?: number;
  provision: number;
  comment?: string;
  catalogId?: string | null;
  variant?: string | null;
  isCustom?: boolean;
  /**
   * Hidden from the time-entry pickers (tracker, calendar, timesheet) but
   * still counted in the Finance tab's totals — archiving is saisie
   * housekeeping, not an accounting act. Absent means active, so the
   * ~6000 designations imported from Clockify need no migration.
   */
  isArchived?: boolean;
  createdAt: Timestamp;
  updatedAt: Timestamp;
}
